// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-popup {
    position: absolute;
    background: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.15);
    z-index: 2000;
    width: 250px;
    font-size: 14px;
  }
  
  .profile-popup {
    top: 80px; /* adjust to match your navbar position */
    left: 100px;
  }
  
  .event-popup {
    top: 200px; /* adjust to match event creation button position */
    left: 300px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/OnboardingPopup.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS,EAAE,yCAAyC;IACpD,WAAW;EACb;;EAEA;IACE,UAAU,EAAE,mDAAmD;IAC/D,WAAW;EACb","sourcesContent":[".onboarding-popup {\n    position: absolute;\n    background: #fff;\n    padding: 12px 16px;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(0,0,0,0.15);\n    z-index: 2000;\n    width: 250px;\n    font-size: 14px;\n  }\n  \n  .profile-popup {\n    top: 80px; /* adjust to match your navbar position */\n    left: 100px;\n  }\n  \n  .event-popup {\n    top: 200px; /* adjust to match event creation button position */\n    left: 300px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
